import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Box,
  Button,
  TextField,
  Alert,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  LinearProgress,
  CircularProgress,
  Stepper,
  Step,
  StepLabel,
  IconButton,
  TablePagination,
} from "@mui/material";
import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import InfoIcon from "@mui/icons-material/Info";
import SearchIcon from "@mui/icons-material/Search";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import useAlert from "../hooks/useAlert";

import {
  addCategoryVaiant,
  deleteCategoryVaiant,
  getCategoryVaiant,
  addCategoryVariantValue,
} from "../redux/actions/categorysActions";
import { fetchAttributeAction } from "../redux/actions/attributeAction";
import { getMarketPlaces } from "../redux/actions/marketplacesActions";
import { getEcommercePlaces } from "../redux/actions/ecommercePlaceActions";
import marketplacesService from "../services/marketplacesService";
import ecommercePlaceService from "../services/ecommercePlaceService";
import placesCategoryService from "../services/placesCategoryService";
import categoryService from "../services/categoryService";
import outWardService from "../services/outWardService";
import iaService from "../services/iaService";
import CategoryVariantAdd from "./UI/reusable-components/CategoryVariantComponents/AddCategoryVariant";
import AddCategoryVariantValue from "./UI/reusable-components/CategoryVariantComponents/AddCategoryVariantValue";

export const CategoryVariant = () => {
  const [data, setData] = useState([]);
  const [recordsTotal, setRecordsTotal] = useState(0);
  const [searchVisible, setSearchVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  // searchTerm her tuşta değişir, debouncedSearch ise API'ye gidecek gerçek değer - aksi halde
  // her karakterde ayrı bir DB sorgusu atılır
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [listLoading, setListLoading] = useState(true);
  // Backend artık bu listeyi DB seviyesinde sayfalıyor/arıyor (page/pageSize/search), tarayıcı
  // sadece seçili sayfayı gösteriyor
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const dispatch = useDispatch();

  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);

  // AI ile toplu Varyant (attribute adı) eşleştirme - akış: pazaryeri seçilir, o pazaryerine
  // eşleşmiş TÜM kategoriler taranır, her kategorinin eşleşmemiş TÜM attribute'ları için AI
  // bizim varyant adlarımız arasından en uygununu seçer (kullanıcı tek tek varyant seçmez)
  const [aiModalOpen, setAiModalOpen] = useState(false);
  const [aiModalStep, setAiModalStep] = useState("place"); // place | preview | running | done
  const [aiOurAttributeNames, setAiOurAttributeNames] = useState([]);
  const [aiModalPlace, setAiModalPlace] = useState(null);
  const [aiAllPlaces, setAiAllPlaces] = useState([]);
  const [aiPreviewLoading, setAiPreviewLoading] = useState(false);
  const [aiUnmatchedList, setAiUnmatchedList] = useState([]);
  const [aiSelectedIds, setAiSelectedIds] = useState([]);
  const [aiConsentChecked, setAiConsentChecked] = useState(false);
  const [aiMatching, setAiMatching] = useState(false);
  const [aiProgress, setAiProgress] = useState({ current: 0, total: 0 });
  const [aiSummary, setAiSummary] = useState(null);

  // AI ile toplu Varyant DEĞERİ eşleştirme - akış: pazaryeri seç -> o pazaryerinde zaten
  // eşleşmiş TÜM varyant (attribute) satırları taranır, her birinde pazaryerinin sahip
  // olduğu TÜM değerler sırayla AI ile eşleştirilir (kullanıcı tek tek varyant seçmiyor,
  // Faz 1'deki "Varyant Eşleştir" ile aynı mantık)
  const [aiValueModalOpen, setAiValueModalOpen] = useState(false);
  const [aiValueModalStep, setAiValueModalStep] = useState("place"); // place | preview | running | done
  // AI'a değer adayı olarak gönderilecek liste GetGroupByValue (isGroupValue=true) ile gelen
  // gerçek attribute değerleri
  const [aiValueOurAllNames, setAiValueOurAllNames] = useState([]);
  const [aiValueModalPlace, setAiValueModalPlace] = useState(null);
  const [aiValuePreviewLoading, setAiValuePreviewLoading] = useState(false);
  const [aiValueUnmatchedList, setAiValueUnmatchedList] = useState([]);
  const [aiValueSelectedIds, setAiValueSelectedIds] = useState([]);
  const [aiValueConsentChecked, setAiValueConsentChecked] = useState(false);
  const [aiValueMatching, setAiValueMatching] = useState(false);
  const [aiValueProgress, setAiValueProgress] = useState({ current: 0, total: 0 });
  const [aiValueSummary, setAiValueSummary] = useState(null);

  const handleSearchToggle = () => {
    setSearchVisible((prev) => !prev);
    setSearchTerm("");
    setDebouncedSearch("");
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  // Arama kutusuna yazarken her tuşta değil, kullanıcı durduktan 400ms sonra DB'ye sorgu atılır
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearch(searchTerm.trim());
      setPage(1);
    }, 400);
    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const [openValueModal, setOpenValueModal] = useState(false);
  const [selectedVariantForValue, setSelectedVariantForValue] = useState(null);

  const handleOpenValueModal = (item) => {
    setSelectedVariantForValue(item);
    setOpenValueModal(true);
  };
  const handleCloseValueModal = () => {
    setOpenValueModal(false);
    setSelectedVariantForValue(null);
  };
  const {
    showSuccessAlertCategoryVariantDelete,
    showErrorAlertCategoryVariantDelete,
  } = useAlert();

  // Görüntülenen sayfayı/aramayı koruyarak listeyi DB'den yeniden çeker - hem ilk yüklemede hem
  // silme/AI eşleştirme sonrası yenilemede kullanılıyor
  const fetchList = () => {
    if (!authUserId) {
      setListLoading(false);
      return;
    }
    setListLoading(true);
    dispatch(getCategoryVaiant(authUserId, token, page, rowsPerPage, debouncedSearch))
      .then((result) => {
        setData(result?.data ?? []);
        setRecordsTotal(result?.recordsTotal ?? 0);
      })
      .catch(() => {})
      .finally(() => setListLoading(false));
  };

  const deleteCategoryVariant = async (id) => {
    const confirmDelete = window.confirm(
      "Bu eşleştirmeyi silmek istediğinizden emin misiniz?"
    );

    if (confirmDelete) {
      try {
        const response = await dispatch(deleteCategoryVaiant(id, token));

        if (response) {
          showSuccessAlertCategoryVariantDelete();
          fetchList();
        }
        return response;
      } catch (error) {
        showErrorAlertCategoryVariantDelete();
        console.error("Error deleting address:", error);
      }
    }
  };

  useEffect(() => {
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUserId, page, rowsPerPage, debouncedSearch]);

  const handleOpenAiModal = async () => {
    setAiModalOpen(true);
    setAiModalStep("place");
    setAiModalPlace(null);
    setAiUnmatchedList([]);
    setAiSelectedIds([]);
    setAiConsentChecked(false);
    setAiSummary(null);
    setAiProgress({ current: 0, total: 0 });

    try {
      const [marketResponse, ecommerceResponse, ourNames] = await Promise.all([
        dispatch(getMarketPlaces(token)),
        dispatch(getEcommercePlaces(token)),
        dispatch(fetchAttributeAction(authUserId, token, true)), // sadece gerçek varyant adları
      ]);
      const marketList = Array.isArray(marketResponse)
        ? marketResponse
        : marketResponse?.data ?? [];
      const ecommerceList = Array.isArray(ecommerceResponse)
        ? ecommerceResponse
        : ecommerceResponse?.data ?? [];
      setAiAllPlaces([
        ...marketList.map((item) => ({ ...item, type: "marketplace" })),
        ...ecommerceList.map((item) => ({ ...item, type: "ecommerce" })),
      ]);
      setAiOurAttributeNames(Array.isArray(ourNames) ? ourNames : []);
    } catch (error) {
      console.error("Veriler alınırken hata oluştu:", error);
    }
  };

  const handleCloseAiModal = () => {
    if (aiMatching) return; // eşleştirme sürerken modal kapatılamaz
    const shouldRefresh = aiModalStep === "done";
    setAiModalOpen(false);
    setAiModalStep("place");
    setAiModalPlace(null);
    setAiUnmatchedList([]);
    setAiSelectedIds([]);
    setAiConsentChecked(false);
    setAiSummary(null);
    if (shouldRefresh) {
      fetchList();
    }
  };

  // AddCategoryVariant.jsx'deki createRequestBodyAttribute ile aynı - CategoryAttribute
  // endpoint'i için pazaryeri/e-ticaret hesap ayarlarını hazırlar
  const buildCategoryAttributeRequestBody = (
    marketPlaceCategoryId,
    selectedPlaceName,
    marketAccounts,
    ecomAccounts
  ) => {
    const marketPlaceSettings = marketAccounts
      .filter((account) => account.marketPlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        marketPlaceId: account.marketPlaceId || 0,
        marketPlaceName: account.marketPlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));
    const ecommercePlaceSettings = ecomAccounts
      .filter((account) => account.ecommercePlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        ecommercePlaceId: account.ecommercePlaceId || 0,
        ecommercePlaceName: account.ecommercePlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));

    return {
      categoriId: marketPlaceCategoryId,
      userId: authUserId,
      marketPlaceSetting: marketPlaceSettings,
      EcommercePlaceSettings: ecommercePlaceSettings,
      startDate: new Date().toISOString(),
      endDate: new Date().toISOString(),
      page: 0,
      size: 100,
    };
  };

  // Seçilen pazaryerine zaten eşleşmiş TÜM kategorileri tarar; her kategori için pazaryerinin
  // TÜM attribute listesini (kategori başına tek çağrı) çeker. Döngü BİZİM varyant isimlerimiz
  // üzerinden döner (pazaryerinin attribute'ları üzerinden değil): her kategoride, henüz bir
  // eşlemesi olmayan her bizim ismimiz için bir aday satırı oluşturulur. Böylece AI her ismi
  // sadece BİR kez, o kategorinin pazaryeri attribute'ları arasından en uygunuyla eşleştirir -
  // aynı bizim ismin (ör. "Renk") aynı kategoride iki farklı pazaryeri alanına (Primary/Secondary
  // color) atanması artık mümkün değil.
  const handleAiPlaceNext = async () => {
    if (!aiModalPlace?.id) return;

    setAiPreviewLoading(true);
    try {
      const platformType = aiModalPlace.type === "marketplace" ? "marketplace" : "ecommerce";

      const [marketAccountsRes, ecomAccountsRes, matchedCategoriesRes, existingVariantsRes] =
        await Promise.all([
          marketplacesService.getMarketPlacesAccountsApi(authUserId, token),
          ecommercePlaceService.getEcommercePlaceAccountsApi(authUserId, token),
          placesCategoryService.fetchPlaceCategories({
            MarketPlaceId: platformType === "marketplace" ? aiModalPlace.id : undefined,
            EcommercePlaceId: platformType === "ecommerce" ? aiModalPlace.id : undefined,
            UserId: authUserId,
          }),
          categoryService.getCategoriyVariantApi(authUserId, token, undefined, undefined, undefined, true),
        ]);

      const marketAccounts = marketAccountsRes?.data?.data?.data ?? [];
      const ecomAccounts = ecomAccountsRes?.data?.data?.data ?? [];
      const matchedCategories = matchedCategoriesRes?.data?.data ?? [];

      // Bu pazaryerinde, hangi kategoride hangi bizim ismimizin ZATEN bir eşlemesi var - diff için
      const existingRows =
        existingVariantsRes?.data?.data?.data ?? existingVariantsRes?.data?.data ?? [];
      const existingKeys = new Set(
        existingRows
          .filter((row) => {
            const rowPlaceId =
              platformType === "marketplace" ? row.marketPlaceId : row.ecommercePlaceId;
            return rowPlaceId === aiModalPlace.id;
          })
          .map((row) => `${row.categoryId}-${row.pcVariantName}`)
      );

      const unmatched = [];
      for (const placeCategory of matchedCategories) {
        const categoryId = placeCategory.categoryId;
        const categoryName = placeCategory.category?.name ?? "";
        const marketPlaceCategoryId = placeCategory.marketPlaceCategoryId;
        const marketPlaceCategoryName = placeCategory.marketPlaceCategoryName;
        if (!categoryId || !marketPlaceCategoryId) continue;

        try {
          const requestBody = buildCategoryAttributeRequestBody(
            marketPlaceCategoryId,
            aiModalPlace.name,
            marketAccounts,
            ecomAccounts
          );
          const attributes = await outWardService.fetchCategoryAttribute(
            aiModalPlace.name,
            requestBody,
            token
          );

          const attributeCandidates = (attributes ?? [])
            .filter((item) => item?.attribute?.id && item?.attribute?.name)
            .map((item) => ({ id: item.attribute.id, name: item.attribute.name }));

          if (attributeCandidates.length === 0) continue;

          aiOurAttributeNames.forEach((ourName) => {
            const key = `${categoryId}-${ourName}`;
            if (existingKeys.has(key)) return;

            unmatched.push({
              key,
              categoryId,
              categoryName,
              marketPlaceCategoryId,
              marketPlaceCategoryName,
              ourName,
              attributeCandidates,
            });
          });
        } catch (error) {
          console.error(`${categoryName} için varyantlar alınırken hata oluştu:`, error);
        }
      }

      setAiUnmatchedList(unmatched);
      setAiSelectedIds(unmatched.map((item) => item.key));
      setAiModalStep("preview");
    } catch (error) {
      console.error("Eşleşmemiş varyantlar alınırken hata oluştu:", error);
      setAiSummary({ error: true });
      setAiModalStep("preview");
    } finally {
      setAiPreviewLoading(false);
    }
  };

  const handleToggleAiItem = (key) => {
    setAiSelectedIds((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  const handleToggleAiSelectAll = () => {
    setAiSelectedIds((prev) =>
      prev.length === aiUnmatchedList.length ? [] : aiUnmatchedList.map((item) => item.key)
    );
  };

  // Onay sonrası asıl AI eşleştirme döngüsü - her satır için AI, sabit bizim varyant ismimize
  // (item.ourName) o kategorinin pazaryeri attribute'ları arasından en uygununu buluyor
  const handleAiMatchRun = async () => {
    const itemsToMatch = aiUnmatchedList.filter((item) => aiSelectedIds.includes(item.key));
    if (!aiModalPlace?.id || itemsToMatch.length === 0) return;

    setAiModalStep("running");
    setAiMatching(true);
    setAiSummary(null);
    setAiProgress({ current: 0, total: itemsToMatch.length });

    try {
      const platformType = aiModalPlace.type === "marketplace" ? "marketplace" : "ecommerce";

      let matched = 0;
      let failed = 0;

      for (let i = 0; i < itemsToMatch.length; i++) {
        const item = itemsToMatch[i];

        try {
          const aiResult = await iaService.match(
            item.ourName,
            JSON.stringify(item.attributeCandidates),
            token
          );

          if (aiResult?.id) {
            const matchingData = {
              variantName: aiResult.name,
              variantId: aiResult.id,
              pcVariantName: item.ourName,
              MarketPlaceId: platformType === "marketplace" ? aiModalPlace.id : null,
              EcommercePlaceId: platformType === "ecommerce" ? aiModalPlace.id : null,
              CategoryId: item.categoryId,
              MarketPlaceCategoryId: item.marketPlaceCategoryId,
              MarketPlaceCategoryName: item.marketPlaceCategoryName,
              CreateDate: new Date().toISOString(),
              UpdateDate: new Date().toISOString(),
              IA: true,
              userId: authUserId,
            };

            await dispatch(addCategoryVaiant(matchingData, token));
            matched++;
          } else {
            failed++;
          }
        } catch (error) {
          console.error("AI varyant eşleştirme sırasında hata:", item, error);
          failed++;
        }

        setAiProgress({ current: i + 1, total: itemsToMatch.length });
      }

      setAiSummary({ matched, failed, total: itemsToMatch.length });
      setAiModalStep("done");
    } catch (error) {
      console.error("AI toplu varyant eşleştirme başlatılırken hata oluştu:", error);
      setAiSummary({ error: true });
      setAiModalStep("done");
    } finally {
      setAiMatching(false);
    }
  };

  // ---- AI ile toplu Varyant DEĞERİ eşleştirme ----

  const handleOpenAiValueModal = async () => {
    setAiValueModalOpen(true);
    setAiValueModalStep("place");
    setAiValueModalPlace(null);
    setAiValueUnmatchedList([]);
    setAiValueSelectedIds([]);
    setAiValueConsentChecked(false);
    setAiValueSummary(null);
    setAiValueProgress({ current: 0, total: 0 });

    try {
      const [marketResponse, ecommerceResponse, ourAllNames] = await Promise.all([
        dispatch(getMarketPlaces(token)),
        dispatch(getEcommercePlaces(token)),
        dispatch(fetchAttributeAction(authUserId, token, false, true)), // AI'a gerçek değer adayı olarak
      ]);
      const marketList = Array.isArray(marketResponse)
        ? marketResponse
        : marketResponse?.data ?? [];
      const ecommerceList = Array.isArray(ecommerceResponse)
        ? ecommerceResponse
        : ecommerceResponse?.data ?? [];
      setAiAllPlaces([
        ...marketList.map((item) => ({ ...item, type: "marketplace" })),
        ...ecommerceList.map((item) => ({ ...item, type: "ecommerce" })),
      ]);
      setAiValueOurAllNames(Array.isArray(ourAllNames) ? ourAllNames : []);
    } catch (error) {
      console.error("Veriler alınırken hata oluştu:", error);
    }
  };

  const handleCloseAiValueModal = () => {
    if (aiValueMatching) return; // eşleştirme sürerken modal kapatılamaz
    setAiValueModalOpen(false);
    setAiValueModalStep("place");
    setAiValueModalPlace(null);
    setAiValueUnmatchedList([]);
    setAiValueSelectedIds([]);
    setAiValueConsentChecked(false);
    setAiValueSummary(null);
  };

  // Seçilen pazaryerinde zaten eşleşmiş TÜM varyant (attribute) satırlarını tarar - hangi
  // "bizim varyant" olduğuna bakılmaksızın. Döngü BİZİM değerlerimiz üzerinden döner (pazaryerinin
  // değerleri üzerinden değil, Faz 1'deki "Varyant Eşleştir" düzeltmesiyle aynı mantık): her satırda,
  // henüz bir eşlemesi olmayan her bizim değerimiz için bir aday satırı oluşturulur. AI her değeri
  // sadece BİR kez, o satırın pazaryeri değerleri arasından en uygunuyla eşleştirir - aynı bizim
  // değerin (ör. "Kırmızı") aynı satırda birden fazla farklı pazaryeri değerine atanması, ürün
  // gönderiminde hangisinin kullanılacağını belirsizleştirmesin diye artık mümkün değil.
  const handleAiValuePlaceNext = async () => {
    if (!aiValueModalPlace?.id) return;

    setAiValuePreviewLoading(true);
    try {
      const platformType = aiValueModalPlace.type === "marketplace" ? "marketplace" : "ecommerce";

      // Tablo artık sayfalı (sadece görünen sayfa `data` içinde) - burada TÜM satırlara ihtiyaç
      // var, bu yüzden closePagination:true ile ayrı bir tam liste çekiyoruz
      const [marketAccountsRes, ecomAccountsRes, allVariantsRes] = await Promise.all([
        marketplacesService.getMarketPlacesAccountsApi(authUserId, token),
        ecommercePlaceService.getEcommercePlaceAccountsApi(authUserId, token),
        categoryService.getCategoriyVariantApi(authUserId, token, undefined, undefined, undefined, true),
      ]);
      const allVariantRows =
        allVariantsRes?.data?.data?.data ?? allVariantsRes?.data?.data ?? [];

      const matchingRows = allVariantRows.filter((row) => {
        const rowPlaceId = platformType === "marketplace" ? row.marketPlaceId : row.ecommercePlaceId;
        return rowPlaceId === aiValueModalPlace.id;
      });

      if (matchingRows.length === 0) {
        setAiValueUnmatchedList([]);
        setAiValueSelectedIds([]);
        setAiValueModalStep("preview");
        return;
      }
      const marketAccounts = marketAccountsRes?.data?.data?.data ?? [];
      const ecomAccounts = ecomAccountsRes?.data?.data?.data ?? [];

      const candidates = [];
      for (const row of matchingRows) {
        try {
          // Bu satırda hangi bizim değerimizin ZATEN bir eşlemesi var - diff için
          const existingValuesRes = await categoryService.getCategoryVariantValueApi(row.id, token);
          const existingValues =
            existingValuesRes?.data?.data?.data ?? existingValuesRes?.data?.data ?? [];
          const existingValueNames = new Set(existingValues.map((v) => v.pcVariantValueName));

          // AddCategoryVariantValue.jsx'deki loadMarketplaceAttributeValues ile aynı - bizim
          // kategori id'mizden bu pazaryerine ait MarketPlaceCategoryId'yi buluyoruz
          const placeCategory = row.category?.placeCategories?.find(
            (pc) =>
              pc.marketPlaceName === row.marketPlaceName ||
              pc.ecommercePlaceName === row.marketPlaceName
          );
          if (!placeCategory?.marketPlaceCategoryId) continue;

          const requestBody = buildCategoryAttributeRequestBody(
            placeCategory.marketPlaceCategoryId,
            row.marketPlaceName,
            marketAccounts,
            ecomAccounts
          );
          const attributes = await outWardService.fetchCategoryAttribute(
            row.marketPlaceName,
            requestBody,
            token
          );

          const matchedAttribute = (attributes ?? []).find(
            (item) => item?.attribute?.id === row.variantId
          );
          const valueCandidates = (matchedAttribute?.attributeValues ?? [])
            .filter((v) => v?.id && v?.name)
            .map((v) => ({ id: v.id, name: v.name }));

          if (valueCandidates.length === 0) continue;

          aiValueOurAllNames.forEach((ourValueName) => {
            if (existingValueNames.has(ourValueName)) return;

            candidates.push({
              key: `${row.id}-${ourValueName}`,
              placeCategoryVariantId: row.id,
              categoryName: row.category?.name ?? "",
              marketPlaceAttributeName: row.variantName,
              ourValueName,
              valueCandidates,
            });
          });
        } catch (error) {
          console.error("Değer adayları alınırken hata oluştu:", row, error);
        }
      }

      setAiValueUnmatchedList(candidates);
      setAiValueSelectedIds(candidates.map((item) => item.key));
      setAiValueModalStep("preview");
    } catch (error) {
      console.error("Eşleşmemiş değerler alınırken hata oluştu:", error);
      setAiValueSummary({ error: true });
      setAiValueModalStep("preview");
    } finally {
      setAiValuePreviewLoading(false);
    }
  };

  const handleToggleAiValueItem = (key) => {
    setAiValueSelectedIds((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  const handleToggleAiValueSelectAll = () => {
    setAiValueSelectedIds((prev) =>
      prev.length === aiValueUnmatchedList.length
        ? []
        : aiValueUnmatchedList.map((item) => item.key)
    );
  };

  // Her satır için AI'a sabit bizim değerimiz (item.ourValueName) gönderilir, adaylar = o satırın
  // pazaryeri değerleri; AI en uygun pazaryeri değerini seçer
  const handleAiValueMatchRun = async () => {
    const itemsToMatch = aiValueUnmatchedList.filter((item) =>
      aiValueSelectedIds.includes(item.key)
    );
    if (itemsToMatch.length === 0) return;

    setAiValueModalStep("running");
    setAiValueMatching(true);
    setAiValueSummary(null);
    setAiValueProgress({ current: 0, total: itemsToMatch.length });

    try {
      let matched = 0;
      let failed = 0;

      for (let i = 0; i < itemsToMatch.length; i++) {
        const item = itemsToMatch[i];

        try {
          const aiResult = await iaService.match(
            item.ourValueName,
            JSON.stringify(item.valueCandidates),
            token
          );

          if (aiResult?.id) {
            const matchingData = {
              PlaceCategoryVariantId: item.placeCategoryVariantId,
              PcVariantValueName: item.ourValueName,
              VariantValueId: aiResult.id,
              VariantValueName: aiResult.name,
              CreateDate: new Date().toISOString(),
              UpdateDate: new Date().toISOString(),
              Ia: true,
              UserId: authUserId,
            };

            await dispatch(addCategoryVariantValue(matchingData, token));
            matched++;
          } else {
            failed++;
          }
        } catch (error) {
          console.error("AI değer eşleştirme sırasında hata:", item, error);
          failed++;
        }

        setAiValueProgress({ current: i + 1, total: itemsToMatch.length });
      }

      setAiValueSummary({ matched, failed, total: itemsToMatch.length });
      setAiValueModalStep("done");
    } catch (error) {
      console.error("AI toplu değer eşleştirme başlatılırken hata oluştu:", error);
      setAiValueSummary({ error: true });
      setAiValueModalStep("done");
    } finally {
      setAiValueMatching(false);
    }
  };

  return (
    <Box sx={{ width: "100%", padding: { xs: 1, sm: 2, md: 3 } }}>
      <Alert
        sx={{ mb: 2, fontSize: { xs: "0.875rem", sm: "1rem" } }}
        severity="info"
        icon={<InfoIcon />}
      >
        <strong>Bilgi:</strong> Kategori varyant eşleştirmeleri, XML verilerindeki varyant değerlerinin ilgili pazaryeri kategorilerindeki karşılıklarıyla doğru şekilde eşleştirilmesini sağlar. İşlem öncesinde aşağıdaki sıraya uyulması önerilir.
      </Alert>

      <Card
        sx={{
          mb: 3,
          backgroundColor: "#E3F2FD",
          borderLeft: "4px solid #2196F3",
        }}
      >
        <CardContent>
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <InfoIcon sx={{ mr: 1, color: "#2196F3" }} />
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Kategori Varyant Eşleştirmesi Nasıl Yapılır?
            </Typography>
          </Box>
          <Typography variant="body2" sx={{ ml: 4, color: "#424242" }}>
            XML kaynağından gelen varyant değerleri (örneğin beden, numara vb.) her pazaryerinde farklı kategori alanlarına karşılık gelebilir. Aynı &quot;beden&quot; verisi N11 tarafında &quot;numara&quot;, Hepsiburada tarafında ise &quot;ayakkabı numarası&quot; alanına denk gelebilir. Bu nedenle eşleştirme işleminde aşağıdaki sıranın izlenmesi gerekmektedir:
            <br />
            <br />
            <strong>İşlem sırası:</strong>
            <br />
            • <strong>1. Pazaryeri seçimi:</strong> Öncelikle ürünün gönderileceği pazaryeri seçilmelidir.
            <br />
            • <strong>2. Sistem varyant değeri:</strong> Ardından sistemde tanımlı ve XML’den gelen varyant değeri (ör. Beden, Renk) seçilmelidir.
            <br />
            • <strong>3. Ürün kategorisi:</strong> Ürünün hangi kategoride listeleneceği belirlenmelidir.
            <br />
            • <strong>4. Pazaryeri kategorisi:</strong> Seçilen pazaryerine ait ilgili kategori seçilmelidir.
            <br />
            • <strong>5. Pazaryeri varyant değeri:</strong> Son adımda, ilgili pazaryeri kategorisindeki varyantlar arasından gönderimde kullanılacak varyant değeri seçilmelidir.
            <br />
            <br />
            <strong>Örnek uygulama:</strong> Trendyol pazaryeri seçildikten sonra, hata veren veya uyumsuz gelen varyant değeri olarak sistemde &quot;Beden&quot; seçilmiş ve &quot;Ayakkabı&quot; kategorisi belirlenmiştir. Ardından Trendyol kategorilerinden ilgili ayakkabı kategorisi seçilerek, bu kategorideki varyantlar arasından ürünün gönderileceği doğru varyant değeri (ör. ayakkabı numarası) seçilmelidir.
          </Typography>
        </CardContent>
      </Card>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 2 }}>
          <Button
            sx={{ borderRadius: 1 }}
            size="small"
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleOpenModal}
          >
            Ekle
          </Button>
          <Button
            size="small"
            variant="contained"
            color="primary"
            startIcon={<AutoAwesomeIcon />}
            onClick={handleOpenAiModal}
            sx={{
              borderRadius: 1,
              textTransform: "none",
              "@keyframes aiButtonGlowVariant": {
                "0%, 100%": { boxShadow: "0 0 0 0 rgba(21,101,192,0.5)" },
                "50%": { boxShadow: "0 0 0 8px rgba(21,101,192,0)" },
              },
              animation: "aiButtonGlowVariant 2s ease-in-out infinite",
            }}
          >
            Yapay Zeka ile Eşleştir
          </Button>
          <Button
            size="small"
            variant="contained"
            color="primary"
            startIcon={<AutoAwesomeIcon />}
            onClick={handleOpenAiValueModal}
            sx={{
              borderRadius: 1,
              textTransform: "none",
              "@keyframes aiButtonGlowValue": {
                "0%, 100%": { boxShadow: "0 0 0 0 rgba(21,101,192,0.5)" },
                "50%": { boxShadow: "0 0 0 8px rgba(21,101,192,0)" },
              },
              animation: "aiButtonGlowValue 2s ease-in-out infinite",
            }}
          >
            Yapay Zeka ile Değer Eşleştir
          </Button>
          <Button
            sx={{ borderRadius: 1 }}
            size="small"
            variant="contained"
            color="primary"
            startIcon={<SearchIcon />}
            onClick={handleSearchToggle}
          >
            Filtrele
          </Button>
        </Box>
      </Box>

      {searchVisible && (
        <Box sx={{ mb: 3 }}>
          <TextField
            fullWidth
            label="Kategori, varyant veya pazaryeri adına göre ara"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </Box>
      )}

      <TableContainer
        sx={{
          maxHeight: 670,
          maxWidth: "100%",
          p: 3,
          background: "white",
          borderRadius: 1,
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Kategori Adı</TableCell>
              <TableCell>Pazaryeri Varyant Adı</TableCell>
              <TableCell>Pazaryeri</TableCell>
              <TableCell>Varyant adı </TableCell>
              <TableCell sx={{ width: 350 }}>İşlemler</TableCell>
            </TableRow>
          </TableHead>
          {listLoading ? (
            <TableBody>
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                  <CircularProgress size={28} />
                </TableCell>
              </TableRow>
            </TableBody>
          ) : data?.length > 0 ? (
            <TableBody>
              {data.map((item, index) => (
                <TableRow key={item.id ?? index} sx={{ background: "white" }}>
                  <TableCell>{item?.category?.name}</TableCell>
                  <TableCell>{item?.variantName}</TableCell>
                  <TableCell>
                    {item?.marketPlaceName || item?.ecommercePlace?.name}
                  </TableCell>
                  <TableCell>{item.pcVariantName}</TableCell>
                  <TableCell>
                    <Button
                      sx={{
                        borderRadius: 1,
                        mr: 1,
                      }}
                      size="small"
                      variant="outlined"
                      color="primary"
                      onClick={() => handleOpenValueModal(item)}
                    >
                      Değerleri Eşleştir
                    </Button>
                    <Button
                      sx={{
                        borderRadius: 1,
                      }}
                      size="small"
                      variant="contained"
                      color="primary"
                      onClick={() => deleteCategoryVariant(item.id)}
                    >
                      Sil
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell colSpan={5} align="center">
                  {searchTerm
                    ? "Aramanızla eşleşen kategori varyantı bulunamadı"
                    : "Henüz kategori varyantı eşleşirilmedi"}
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
        {!listLoading && recordsTotal > 0 && (
          <TablePagination
            component="div"
            count={recordsTotal}
            page={page - 1}
            onPageChange={(event, newPage) => setPage(newPage + 1)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(1);
            }}
            rowsPerPageOptions={[10, 25, 50, 100]}
            labelRowsPerPage="Sayfa başına satır"
            labelDisplayedRows={({ from, to, count }) => `${from}–${to} / ${count}`}
          />
        )}
      </TableContainer>
      <CategoryVariantAdd open={openModal} handleClose={handleCloseModal} />
      <AddCategoryVariantValue
        open={openValueModal}
        handleClose={handleCloseValueModal}
        placeCategoryVariant={selectedVariantForValue}
      />

      {/* Yapay Zeka ile Toplu Varyant Eşleştirme Modalı */}
      <Dialog
        open={aiModalOpen}
        onClose={(event, reason) => {
          if (reason === "backdropClick") return;
          handleCloseAiModal();
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2, overflow: "hidden" } }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1.5,
            px: 3,
            py: 2,
            background: "linear-gradient(135deg, #1565c0 0%, #1e88e5 100%)",
            color: "#fff",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <AutoAwesomeIcon sx={{ fontSize: 26 }} />
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.3 }}>
                Yapay Zeka ile Varyant Eşleştir
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.9 }}>
                {aiModalPlace?.name ?? "Pazaryeri seçilmedi"}
              </Typography>
            </Box>
          </Box>
          <IconButton
            size="small"
            onClick={handleCloseAiModal}
            disabled={aiMatching}
            sx={{ color: "#fff" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <Box sx={{ px: 3, pt: 2.5, pb: 1, backgroundColor: "#fafbfc" }}>
          <Stepper
            activeStep={{ place: 0, preview: 1, running: 2, done: 3 }[aiModalStep]}
            alternativeLabel
          >
            {["Pazaryeri Seç", "Önizleme & Onay", "Eşleştiriliyor", "Sonuç"].map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>

        <DialogContent dividers sx={{ backgroundColor: "#fafbfc" }}>
          {aiModalStep === "place" && (
            <Box
              sx={{
                backgroundColor: "#fff",
                border: "1px solid #e6e8ec",
                borderRadius: 2,
                p: 2.5,
              }}
            >
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Varyant eşleştirmesi yapmak istediğiniz pazaryerini seçin. Bu pazaryerine
                kategori olarak zaten eşleşmiş tüm kategorileriniz taranacak; her kategorinin
                pazaryerinde henüz eşleşmemiş tüm varyantları için AI, bizim varyant
                adlarımız arasından en uygununu kendisi bulup kaydedecek.
              </Typography>
              <TextField
                select
                fullWidth
                size="small"
                label="Pazaryeri"
                value={aiModalPlace ?? ""}
                onChange={(e) => setAiModalPlace(e.target.value)}
              >
                {aiAllPlaces.map((place) => (
                  <MenuItem key={`${place.type}-${place.id}`} value={place}>
                    {place.name}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          )}

          {aiModalStep === "preview" && (
            <Box>
              {aiSummary?.error ? (
                <Alert severity="error">Eşleşmemiş varyantlar alınırken hata oluştu.</Alert>
              ) : aiUnmatchedList.length === 0 ? (
                <Alert severity="info">
                  {aiModalPlace?.name} için eşleşmemiş varyant bulunamadı.
                </Alert>
              ) : (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      backgroundColor: "#fff",
                      border: "1px solid #e6e8ec",
                      borderRadius: 2,
                      px: 2,
                      py: 1.25,
                      mb: 2,
                    }}
                  >
                    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                      {aiModalPlace?.name} tarafında eşleşmemiş {aiUnmatchedList.length} varyant
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: 700,
                        color: "#1565c0",
                        backgroundColor: "#e3f2fd",
                        borderRadius: 5,
                        px: 1.25,
                        py: 0.5,
                      }}
                    >
                      {aiSelectedIds.length} seçili
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      maxHeight: 300,
                      overflowY: "auto",
                      backgroundColor: "#fff",
                      border: "1px solid #e6e8ec",
                      borderRadius: 2,
                      mb: 2,
                    }}
                  >
                    <List dense disablePadding>
                      <ListItem
                        divider
                        sx={{ backgroundColor: "#f0f6fd", borderColor: "#e6e8ec" }}
                      >
                        <FormControlLabel
                          sx={{ ml: 0 }}
                          control={
                            <Checkbox
                              checked={aiSelectedIds.length === aiUnmatchedList.length}
                              indeterminate={
                                aiSelectedIds.length > 0 &&
                                aiSelectedIds.length < aiUnmatchedList.length
                              }
                              onChange={handleToggleAiSelectAll}
                            />
                          }
                          label={<Typography sx={{ fontWeight: 600 }}>Tümünü Seç</Typography>}
                        />
                      </ListItem>
                      {aiUnmatchedList.map((item) => (
                        <ListItem key={item.key} divider sx={{ borderColor: "#f0f1f3" }}>
                          <FormControlLabel
                            sx={{ ml: 0, width: "100%" }}
                            control={
                              <Checkbox
                                checked={aiSelectedIds.includes(item.key)}
                                onChange={() => handleToggleAiItem(item.key)}
                              />
                            }
                            label={
                              <Box>
                                <Typography variant="body2">{item.ourName}</Typography>
                                <Typography variant="caption" color="text.secondary">
                                  {item.categoryName}
                                </Typography>
                              </Box>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Box>
                  <Alert severity="warning" variant="outlined" sx={{ mb: 1.5, borderRadius: 2 }}>
                    Bu işlem listedeki her varyant için yapay zeka servisine ayrı bir istek
                    gönderir ve kullanılan yapay zeka servisine göre ücrete tabi olabilir.
                    Eşleştirme sonucu her zaman doğru olmayabilir, kaydedilen eşleşmeleri kontrol
                    etmenizi öneririz.
                  </Alert>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={aiConsentChecked}
                        onChange={(e) => setAiConsentChecked(e.target.checked)}
                      />
                    }
                    label="Okudum, yukarıdaki varyantların yapay zeka ile eşleştirilmesini onaylıyorum."
                  />
                </>
              )}
            </Box>
          )}

          {aiModalStep === "running" && (
            <Box
              sx={{
                backgroundColor: "#fff",
                border: "1px solid #e6e8ec",
                borderRadius: 2,
                p: 3,
                textAlign: "center",
              }}
            >
              <AutoAwesomeIcon
                sx={{
                  fontSize: 32,
                  color: "#1565c0",
                  mb: 1,
                  "@keyframes aiRunningPulseVariant": {
                    "0%, 100%": { opacity: 1, transform: "scale(1)" },
                    "50%": { opacity: 0.55, transform: "scale(1.15)" },
                  },
                  animation: "aiRunningPulseVariant 1.4s ease-in-out infinite",
                }}
              />
              <Typography variant="body2" sx={{ mb: 2 }}>
                {aiModalPlace?.name} tarafında varyantlar eşleştiriliyor, lütfen bekleyin...
              </Typography>
              <LinearProgress
                variant="determinate"
                value={
                  aiProgress.total > 0
                    ? Math.round((aiProgress.current / aiProgress.total) * 100)
                    : 0
                }
                sx={{ height: 8, borderRadius: 5 }}
              />
              <Typography variant="body2" sx={{ mt: 1.5, fontWeight: 600 }}>
                {aiProgress.current}/{aiProgress.total} varyant işlendi (%
                {aiProgress.total > 0
                  ? Math.round((aiProgress.current / aiProgress.total) * 100)
                  : 0}
                )
              </Typography>
            </Box>
          )}

          {aiModalStep === "done" && (
            <Alert severity={aiSummary?.error ? "error" : "success"} sx={{ borderRadius: 2 }}>
              {aiSummary?.error
                ? "AI toplu varyant eşleştirme sırasında hata oluştu."
                : `Tamamlandı: ${aiSummary?.matched} varyant eşleştirildi, ${aiSummary?.failed} varyant için uygun eşleşme bulunamadı (toplam ${aiSummary?.total}).`}
            </Alert>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2, backgroundColor: "#fafbfc" }}>
          {aiModalStep === "place" && (
            <>
              <Button onClick={handleCloseAiModal}>Vazgeç</Button>
              <Button
                variant="contained"
                color="primary"
                disabled={!aiModalPlace?.id || aiPreviewLoading}
                onClick={handleAiPlaceNext}
                startIcon={
                  aiPreviewLoading ? <CircularProgress size={16} color="inherit" /> : null
                }
              >
                Devam Et
              </Button>
            </>
          )}

          {aiModalStep === "preview" && (
            <>
              <Button onClick={() => setAiModalStep("place")}>Geri</Button>
              <Button onClick={handleCloseAiModal}>Vazgeç</Button>
              {aiUnmatchedList.length > 0 && !aiSummary?.error && (
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!aiConsentChecked || aiSelectedIds.length === 0}
                  onClick={handleAiMatchRun}
                >
                  Eşleştir{aiSelectedIds.length > 0 ? ` (${aiSelectedIds.length})` : ""}
                </Button>
              )}
            </>
          )}

          {aiModalStep === "running" && <Button disabled>Eşleştiriliyor...</Button>}

          {aiModalStep === "done" && (
            <Button variant="contained" color="primary" onClick={handleCloseAiModal}>
              Kapat
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Yapay Zeka ile Toplu Varyant DEĞERİ Eşleştirme Modalı */}
      <Dialog
        open={aiValueModalOpen}
        onClose={(event, reason) => {
          if (reason === "backdropClick") return;
          handleCloseAiValueModal();
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2, overflow: "hidden" } }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1.5,
            px: 3,
            py: 2,
            background: "linear-gradient(135deg, #1565c0 0%, #1e88e5 100%)",
            color: "#fff",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <AutoAwesomeIcon sx={{ fontSize: 26 }} />
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.3 }}>
                Yapay Zeka ile Varyant Değeri Eşleştir
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.9 }}>
                {aiValueModalPlace?.name ?? "Pazaryeri seçilmedi"}
              </Typography>
            </Box>
          </Box>
          <IconButton
            size="small"
            onClick={handleCloseAiValueModal}
            disabled={aiValueMatching}
            sx={{ color: "#fff" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <Box sx={{ px: 3, pt: 2.5, pb: 1, backgroundColor: "#fafbfc" }}>
          <Stepper
            activeStep={{ place: 0, preview: 1, running: 2, done: 3 }[aiValueModalStep]}
            alternativeLabel
          >
            {["Pazaryeri Seç", "Önizleme & Onay", "Eşleştiriliyor", "Sonuç"].map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>

        <DialogContent dividers sx={{ backgroundColor: "#fafbfc" }}>
          {aiValueModalStep === "place" && (
            <Box
              sx={{
                backgroundColor: "#fff",
                border: "1px solid #e6e8ec",
                borderRadius: 2,
                p: 2.5,
              }}
            >
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Varyant değeri eşleştirmesi yapmak istediğiniz pazaryerini seçin. Bu pazaryerinde
                zaten eşleşmiş tüm varyantlar taranacak; her varyantın pazaryerinde henüz
                eşleşmemiş tüm değerleri için AI, bizim değerlerimiz arasından en uygununu
                kendisi bulup kaydedecek.
              </Typography>
              <TextField
                select
                fullWidth
                size="small"
                label="Pazaryeri"
                value={aiValueModalPlace ?? ""}
                onChange={(e) => setAiValueModalPlace(e.target.value)}
              >
                {aiAllPlaces.map((place) => (
                  <MenuItem key={`${place.type}-${place.id}`} value={place}>
                    {place.name}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          )}

          {aiValueModalStep === "preview" && (
            <Box>
              {aiValueSummary?.error ? (
                <Alert severity="error">Eşleşmemiş değerler alınırken hata oluştu.</Alert>
              ) : aiValueUnmatchedList.length === 0 ? (
                <Alert severity="info">
                  {aiValueModalPlace?.name} için eşleşmemiş pazaryeri değeri bulunamadı.
                </Alert>
              ) : (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      backgroundColor: "#fff",
                      border: "1px solid #e6e8ec",
                      borderRadius: 2,
                      px: 2,
                      py: 1.25,
                      mb: 2,
                    }}
                  >
                    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                      {aiValueModalPlace?.name} tarafında eşleşmemiş{" "}
                      {aiValueUnmatchedList.length} pazaryeri değeri
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: 700,
                        color: "#1565c0",
                        backgroundColor: "#e3f2fd",
                        borderRadius: 5,
                        px: 1.25,
                        py: 0.5,
                      }}
                    >
                      {aiValueSelectedIds.length} seçili
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      maxHeight: 300,
                      overflowY: "auto",
                      backgroundColor: "#fff",
                      border: "1px solid #e6e8ec",
                      borderRadius: 2,
                      mb: 2,
                    }}
                  >
                    <List dense disablePadding>
                      <ListItem
                        divider
                        sx={{ backgroundColor: "#f0f6fd", borderColor: "#e6e8ec" }}
                      >
                        <FormControlLabel
                          sx={{ ml: 0 }}
                          control={
                            <Checkbox
                              checked={aiValueSelectedIds.length === aiValueUnmatchedList.length}
                              indeterminate={
                                aiValueSelectedIds.length > 0 &&
                                aiValueSelectedIds.length < aiValueUnmatchedList.length
                              }
                              onChange={handleToggleAiValueSelectAll}
                            />
                          }
                          label={<Typography sx={{ fontWeight: 600 }}>Tümünü Seç</Typography>}
                        />
                      </ListItem>
                      {aiValueUnmatchedList.map((item) => (
                        <ListItem key={item.key} divider sx={{ borderColor: "#f0f1f3" }}>
                          <FormControlLabel
                            sx={{ ml: 0, width: "100%" }}
                            control={
                              <Checkbox
                                checked={aiValueSelectedIds.includes(item.key)}
                                onChange={() => handleToggleAiValueItem(item.key)}
                              />
                            }
                            label={
                              <Box>
                                <Typography variant="body2">
                                  {item.ourValueName}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  {item.categoryName} · {item.marketPlaceAttributeName}
                                </Typography>
                              </Box>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Box>
                  <Alert severity="warning" variant="outlined" sx={{ mb: 1.5, borderRadius: 2 }}>
                    Bu işlem listedeki her kategori için yapay zeka servisine ayrı bir istek
                    gönderir ve kullanılan yapay zeka servisine göre ücrete tabi olabilir.
                    Eşleştirme sonucu her zaman doğru olmayabilir, kaydedilen eşleşmeleri kontrol
                    etmenizi öneririz.
                  </Alert>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={aiValueConsentChecked}
                        onChange={(e) => setAiValueConsentChecked(e.target.checked)}
                      />
                    }
                    label="Okudum, yukarıdaki kategorilerin yapay zeka ile eşleştirilmesini onaylıyorum."
                  />
                </>
              )}
            </Box>
          )}

          {aiValueModalStep === "running" && (
            <Box
              sx={{
                backgroundColor: "#fff",
                border: "1px solid #e6e8ec",
                borderRadius: 2,
                p: 3,
                textAlign: "center",
              }}
            >
              <AutoAwesomeIcon
                sx={{
                  fontSize: 32,
                  color: "#1565c0",
                  mb: 1,
                  "@keyframes aiRunningPulseValue": {
                    "0%, 100%": { opacity: 1, transform: "scale(1)" },
                    "50%": { opacity: 0.55, transform: "scale(1.15)" },
                  },
                  animation: "aiRunningPulseValue 1.4s ease-in-out infinite",
                }}
              />
              <Typography variant="body2" sx={{ mb: 2 }}>
                {aiValueModalPlace?.name} tarafında değerler eşleştiriliyor, lütfen bekleyin...
              </Typography>
              <LinearProgress
                variant="determinate"
                value={
                  aiValueProgress.total > 0
                    ? Math.round((aiValueProgress.current / aiValueProgress.total) * 100)
                    : 0
                }
                sx={{ height: 8, borderRadius: 5 }}
              />
              <Typography variant="body2" sx={{ mt: 1.5, fontWeight: 600 }}>
                {aiValueProgress.current}/{aiValueProgress.total} değer işlendi (%
                {aiValueProgress.total > 0
                  ? Math.round((aiValueProgress.current / aiValueProgress.total) * 100)
                  : 0}
                )
              </Typography>
            </Box>
          )}

          {aiValueModalStep === "done" && (
            <Alert
              severity={aiValueSummary?.error ? "error" : "success"}
              sx={{ borderRadius: 2 }}
            >
              {aiValueSummary?.error
                ? "AI toplu değer eşleştirme sırasında hata oluştu."
                : `Tamamlandı: ${aiValueSummary?.matched} değer eşleştirildi, ${aiValueSummary?.failed} değer için uygun eşleşme bulunamadı (toplam ${aiValueSummary?.total}).`}
            </Alert>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2, backgroundColor: "#fafbfc" }}>
          {aiValueModalStep === "place" && (
            <>
              <Button onClick={handleCloseAiValueModal}>Vazgeç</Button>
              <Button
                variant="contained"
                color="primary"
                disabled={!aiValueModalPlace?.id || aiValuePreviewLoading}
                onClick={handleAiValuePlaceNext}
                startIcon={
                  aiValuePreviewLoading ? <CircularProgress size={16} color="inherit" /> : null
                }
              >
                Devam Et
              </Button>
            </>
          )}

          {aiValueModalStep === "preview" && (
            <>
              <Button onClick={() => setAiValueModalStep("place")}>Geri</Button>
              <Button onClick={handleCloseAiValueModal}>Vazgeç</Button>
              {aiValueUnmatchedList.length > 0 && !aiValueSummary?.error && (
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!aiValueConsentChecked || aiValueSelectedIds.length === 0}
                  onClick={handleAiValueMatchRun}
                >
                  Eşleştir{aiValueSelectedIds.length > 0 ? ` (${aiValueSelectedIds.length})` : ""}
                </Button>
              )}
            </>
          )}

          {aiValueModalStep === "running" && <Button disabled>Eşleştiriliyor...</Button>}

          {aiValueModalStep === "done" && (
            <Button variant="contained" color="primary" onClick={handleCloseAiValueModal}>
              Kapat
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};
